// extracted by mini-css-extract-plugin
export default {"root":"uCbAbFqE5Z","root_danger":"H1pcoBqM7O"};